import { useFormContext } from "react-hook-form";

import { fontSizes } from "#app/theme/v1/fontSizes";
import { Icon } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";
import { Group } from "#shared/view/components/Group";
import { Menu } from "#shared/view/components/Menu";
import { RecommendButtonGroup } from "#shared/view/designSystem/inputs/RecommendButtonGroup";
import { UnitName } from "#shared/view/designSystem/inputs/units";

interface Props {
  companyValue?: { value: number | null; message?: string };
  computedValue?: { value: number | null; message?: string };
  name: string;
  unit?: UnitName;
  unitFactors?: { value: number; unit: UnitName }[];
  precision: number;
  rightSectionRef?: React.RefObject<HTMLDivElement | null>;
  setSelectedFactor: (factor: { value: number; unit: UnitName | undefined }) => void;
}

export const InputRightSection = ({
  companyValue,
  computedValue,
  name,
  unit,
  unitFactors,
  precision,
  rightSectionRef,
  setSelectedFactor,
}: Props) => {
  const { setValue, getValues } = useFormContext();

  const changeUnit = (factor: { value: number; unit: UnitName | undefined }) => {
    const currentValue = getValues(name);
    setValue(name, currentValue);
    setSelectedFactor(factor);
  };

  return (
    <Group wrap="nowrap" gap={"xxs"} ref={rightSectionRef}>
      {unitFactors && (
        <Menu shadow="md" width={200}>
          <Menu.Target>
            <ActionIcon tabIndex={-1}>
              <Icon name="slider" size={parseInt(fontSizes.small)} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={() => changeUnit({ value: 1, unit })}>{unit}</Menu.Item>
            {unitFactors.map((factor) => (
              <Menu.Item key={factor.unit} onClick={() => changeUnit(factor)}>
                {factor.unit}
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        </Menu>
      )}
      <RecommendButtonGroup
        companyValue={companyValue}
        computedValue={computedValue}
        name={name}
        precision={precision}
      />
    </Group>
  );
};
